module.exports = __webpack_public_path__ + "static/media/add.b11ace50.png";